import React, { useState, useEffect, useContext } from 'react';
import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import { LangCtx } from "../../../../lib/context";
import InputField from "../../../../lib/ui/inputs/Input";
import { Auth } from "aws-amplify";
import { Link } from 'react-router-dom';
import { verifyuser } from '../../../../actions/users';
import Button from "../../../../lib/ui/buttons/Button";

const VerifyPopup = (props) => {
    const { l } = useContext(LangCtx);
    const [verifyOtp, setVerifyOtp] = useState(false);
    const [code, setCode] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [counter, setCounter] = useState(40);

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    const handleVerifyOtp = () => {
        Auth.confirmSignUp(props.phone, code)
            .then(data => {
                let body = {
                    phone: props.phone
                }
                verifyuser(body).then(res => {
                    setVerifyOtp(true);
                }).catch(err => {
                    setErrorMsg(err.message)
                })


            })
            .catch(err => {
                setErrorMsg(err.message)
            });
    }

    const handleRensendCode = (e) => {
        e.preventDefault()
        Auth.resendSignUp(props.phone)
            .then(res => {
                if (res && res.data)
                    setErrorMsg('')
                setCounter(40);
            })
            .catch(err => {
                setErrorMsg(err.message)
            });
    }

    return (
        <div className={props.openVerify ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">
                <div className="btmDtlHeader">
                    <span className="hdrTxt">{l.vfy_numb}</span>
                </div>
                <div className="btmDtlBdy">
                    {/* {!confirmOtp ?
                    <div className="colBlock fullWidth">
                        <div className="nodataBlock nopdng">
                            <div className="ndIconBox">
                                <img src="/images/icons/verify.png" alt="verify-icon" />
                            </div>
                            <h2 className="nodataHdng">Enter Your Phone Number</h2>
                            <span className="txtMd txtCenter">We will send you an OTP on your registered mobile number.</span>
                        </div>
                        <form>
                            <small className="inpLabel">Mobile Number<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder="Enter your mobile number"
                                type="text"
                            />
                        </form>
                    </div> */}
                    {!verifyOtp ?
                        <div className="colBlock fullWidth">
                            <div className="nodataBlock nopdng">
                                <div className="ndIconBox">
                                    <img src="/images/icons/verify.png" alt="verify-icon" />
                                </div>
                                <h2 className="nodataHdng">{l.sent_otp}</h2>
                                <span className="txtMd txtCenter">{l.entr_otp}</span>
                            </div>
                            {errorMsg && errorMsg !== "" && <div className="errorBox">
                                <small className="errorTxt">{errorMsg}</small>
                            </div>
                            }
                            <form>
                                <small className="inpLabel">{l.otp}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder="Ex:6876546"
                                    type="text"
                                    onChange={(e) => setCode(e.target.value)}
                                />
                            </form>
                            <div className="rowSpaceBtwn mrgTop24">
                                {counter > 0 ? <p className="pTxt">{l.resend_otp} After <span className="linkTxt">{counter + ' s'}</span></p>
                                    : <Link onClick={handleRensendCode} className="linkTxt">{l.resend_otp}</Link>}
                            </div>
                        </div>
                        :
                        <div className="colBlock fullWidth">
                            <div className="nodataBlock nopdng">
                                <div className="ndIconBox lg noBg">
                                    <img src="/images/icons/verified.png" alt="verify-icon" />
                                </div>
                                <h2 className="nodataHdng">{l.vfy_success}</h2>
                                <span className="txtMd txtCenter">{l.numb_verified}</span>
                            </div>
                        </div>
                    }
                </div>
                {!verifyOtp ?
                    <div className="hdrAction">
                        <div className="hdrActionBox">
                            <span className="hrActionTxt" onClick={props.closePopup}>{l.cancel}</span>
                        </div>
                        <div className="hdrActionBox">
                            <span className="hrActionTxt" onClick={handleVerifyOtp}>{l.vfy}</span>
                        </div>
                    </div>
                    :
                    <div className="hdrActionBox">
                        <Button
                            label={l.okay}
                            type='primary'
                            size='xs'
                            onClick={() => props.handleVerify()}
                        />
                        {/* <span className="hrActionTxt" onClick={() => props.handleVerify()}>{l.okay}</span> */}
                    </div>
                }
            </div>

        </div>
    )
}
export default VerifyPopup;